var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.951,66.891c-.09-.375-.15-.583-.15-.583-.1-.387-.345-.387-.713-.454l-1.991-.279c-.248-.046-.248-.046-.345-.283-.326-.816-.428-1.291-.784-1.291h-3.863c-.356,0-.454.475-.78,1.3-.1.233-.1.233-.345.283l-2,.279c-.364.067-.626.1-.724.492,0,0-.045.171-.139.542-.12.5-.169.442.244.442h11.341C108.12,67.337,108.075,67.387,107.951,66.891Zm-1.286,1.775H97.409c-.623,0-.653.092-.615.612l.7,10.106c.06.512.105.617.656.617h7.771c.551,0,.6-.1.656-.617l.7-10.106C107.317,68.753,107.287,68.665,106.665,68.665Z",
    transform: "translate(-92.038 -62)",
    fill: "#9d9d9c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.8137829584e482f30a2b0c1ad9ec1676.svg";
export { ForwardRef as ReactComponent };